import { useState } from 'react';
import {
  useGetCategories,
  useGetExercises,
  useGetExercisesByCategory,
  useReorderExercises,
} from '@/api/glow-up/glow-up.hooks';

import { ErrorScreen } from '@/components/ui/error-screen';
import { FilterSelect } from '@/components/ui/filter-select';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { SortableList } from '@/components/ui/sortable-list';
import { ExerciseCard } from './ExerciseCard';

type ListProps = {
  refetch: () => void;
};

export const ExerciseList = ({ refetch }: ListProps) => {
  const [categoryId, setCategoryId] = useState<number | null>(null);

  const { categories } = useGetCategories({ skip: 0, take: 1000 });
  const {
    exercises: allExercises,
    isLoading: allLoading,
    isError: allError,
  } = useGetExercises({ skip: 0, take: 1000 });
  const {
    exercises: filteredExercises,
    isLoading: filteredLoading,
    isError: filteredError,
  } = useGetExercisesByCategory(categoryId ?? 0);

  const reorder = useReorderExercises();

  const isLoading = categoryId !== null ? filteredLoading : allLoading;
  const isError = categoryId !== null ? filteredError : allError;
  const exercises =
    categoryId !== null ? (filteredExercises ?? []) : (allExercises ?? []);

  const categoryOptions = (categories ?? []).map((c) => ({
    id: c.id,
    label: c.title,
  }));

  return (
    <div className="flex flex-col gap-4 h-full overflow-auto pb-12">
      <FilterSelect
        value={categoryId}
        onChange={setCategoryId}
        options={categoryOptions}
        placeholder="Toutes les catégories"
      />
      {isLoading && <LoadingScreen />}
      {!isLoading && isError && <ErrorScreen />}
      {!isLoading && !isError && exercises.length === 0 && (
        <p className="text-center text-muted-foreground py-8">
          Aucun exercice pour le moment.
        </p>
      )}
      {!isLoading && !isError && exercises.length > 0 && (
        <SortableList
          items={exercises}
          renderItem={(exercise) => (
            <div className="flex flex-wrap gap-4 py-1">
              <ExerciseCard exercise={exercise} refetch={refetch} />
            </div>
          )}
          onReorder={(items) => reorder.mutate(items)}
        />
      )}
    </div>
  );
};
